module.exports = __webpack_public_path__ + "img/wfqwt.5751eaa.svg";